export const fetchLevel2 = async (context, costCenterElementId, relGroup, relStrategy, relCode) => {
    const getLevel2Details = context.get('Get Level 2 Details');

    const [triggerInput, costCenterVal, relGroupVal, relStrategyVal, relCodeVal] = getLevel2Details.getInputs();

    const [Success, Error, array] = getLevel2Details.getOutputs();

    const getLevel2Details$ = context
        .runner(getLevel2Details)
        .set(costCenterVal, costCenterElementId)
        .set(relGroupVal, relGroup)
        .set(relStrategyVal, relStrategy)
        .set(relCodeVal, relCode)
        .trigger(triggerInput);

    // TODO actually return error when there is one (following line does not work not work, see waitFor doc)
    await getLevel2Details$.waitFor(Success, Error);
    return getLevel2Details$.get(array);
};

export const fetchLevel2WBS = async (context, costCenterElementId, relGroup, relStrategy, relCode) => {
    const getLevel2Details = context.get('Get Level 2 Details - WBS');

    const [triggerInput, costCenterVal, relGroupVal, relStrategyVal, relCodeVal] = getLevel2Details.getInputs();

    const [Success, Error, array] = getLevel2Details.getOutputs();

    const getLevel2Details$ = context
        .runner(getLevel2Details)
        .set(costCenterVal, costCenterElementId)
        .set(relGroupVal, relGroup)
        .set(relStrategyVal, relStrategy)
        .set(relCodeVal, relCode)
        .trigger(triggerInput);

    // TODO actually return error when there is one (following line does not work not work, see waitFor doc)
    await getLevel2Details$.waitFor(Success, Error);
    return getLevel2Details$.get(array);
};
